.kdx-section-bg {
	background-color: $smBanner_bg;		
	position: relative;	

	&.bg-primary {
		background: $smBanner_bg !important;

		* { color: $smBanner_text; }
		.text-white { color: $smBanner_text !important; }
	}
	&.bg-secondary {
		background: $secondary;
	}

	&.bg-tertiary {
		background: $tertiary;
	}

	&.bg-quarternary {
		background: $quarternary;
	}

	&.bg-quinary {
	  background: $quinary;
	}

	&.bg-senary {
	  background: $senary;
	}

	&.bg-gray-lite {
	  background: $gray-lite;
	}

	&.bg-gray-dark {
	  background: $gray-dark;
	}

	&.is-full-bleed {
		padding-top: 0;
		padding-bottom: 0;

		// the background image size will want to be
		// adjusted to only fill the remaining whitespace
		background-size: calc(100% - 41.6666666667%) !important;
	}

	&[bg-repeat] {
		background-size: auto 80%;
		background-repeat: repeat;

		&[bg-repeat="repeat-x"] {
		background-repeat: repeat-x;
		}

		&[bg-repeat="repeat-y"] {
		background-repeat: repeat-y;
		}
	}
	&.animate {
		.row > div {
			opacity: 0;
			transform: translateX(-20px);
			transition: all 800ms;
	
			&.animate-in {
				opacity: 1;
				transform: translateX(0);
			}
		}
	}
	.small-banner{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		padding: 40px 0 40px 100px;
		
		.bck-img{
			position: absolute;
			top: 0;
			left: -30px;
			width: auto;
			height: 100%;

			img { 
				height: 100%; 
				object-fit: cover;
			}
		}
		h2{
			position: relative;
			margin: 0 0 16px 0;
			padding-bottom: 8px;
			@include text-size(30);
			@include line-height(32);

			&::after {
				content: '';
				height: 4px;
				width: 100%;
				max-width: 65px;
				position: absolute;
				top: 100%;
				left: 0;
				background: $smBanner_headingBorder;
			}
		}
		.inner-text{
			flex: 3 0 0%;
			margin: 0px 25px;
			padding:0;
			@include text-size(16);
			@include line-height(30);
			font-weight: 600;
		}
		.ctas {
			text-align: center;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			a {
				display: inline-block;
				margin-bottom: 24px;
				
				&.btn-secondary {
					background-color: $smBanner_mainBtnBG;
					border-color: $smBanner_mainBtnBG;
					color: $smBanner_mainBtnText;
		
					&:hover, &:focus {
						background-color: $smBanner_mainBtnHoverBG;
						border-color: $smBanner_mainBtnHoverBG;
						color: $smBanner_mainBtnHoverText;
					}
				}
				&.arrow-link {
					color: $smBanner_arrowLink;

					svg { fill: $smBanner_arrowLink; }

					&:hover, &:focus {
						color: $smBanner_arrowLink_hover;
						
						svg { fill: currentColor; }
					}
				}
			}
		}
		
	}
}




@include media-breakpoint-down(lg) {
	.kdx-section-bg {

		&.bg-primary {
			background: $smBanner_mobile_bg !important;
		}
		.small-banner {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 32px 0;
			margin: 0;

			.col { padding: 0; }
			h2 {
				padding-bottom: 24px;
				margin: 0 0 24px 0;
				@include text-size(25);
				@include line-height(30);

				&::after {
					left: 50%;
					transform: translateX(-50%);
				}
			}
			.inner-text{
				text-align: center;
				margin: 0;
				flex: 1 1 auto;
				@include text-size(14);
				@include line-height(22);
			}
			.ctas {
				margin-top: 24px;
				flex-direction: column;
			}
		}
		.bck-img{
			display: none;
		}

	}
}




@include media-breakpoint-down(sm) {
	.kdx-section-bg {

		.small-banner {

			.ctas {

				.btn{
					width: 85%;
				}
			}
		}
	}
}